module.exports = __webpack_public_path__ + "img/text1@3x.fefe3ef5.png";